import React from 'react'
import { StaticCmsPage } from './StaticCmsPage.jsx'

export function NewsPage() {
  return <StaticCmsPage slug="nyheder" />
}
